const NavDesktop = (function () {
    'use strict'

    const delay = 400;
    let navpane;
    let timer;
    let uls;

    const reset = function () {
        clearTimeout(timer);
        timer = window.setTimeout(function () {
            $('[data-level=1] > li').removeAttr('data-is-open');
            $(uls).removeAttr('data-is-open');
            $(navpane).removeAttr('data-is-open');
        }, delay);
    }

    const init = function () {
        navpane = $('[data-hook=navpane]');
        uls = $('[data-level]');

        $('[data-level=1] > li').on('mouseover', function () {
            clearTimeout(timer);
        });

        $('[data-level=1] > li[data-has-children]').on('mouseover', function () {
            const that = this;
            clearTimeout(timer);
            timer = window.setTimeout(function () {
                $(navpane).attr('data-is-open', '');
                $(that).siblings().removeAttr('data-is-open');
                $(that).attr('data-is-open', '');
                $(that).find('> ul').attr('data-is-open', '');
            }, delay);
        });

        $(navpane).on('mouseleave', function () {
            reset();
        });
    }

    return {
        init: init,
        reset: reset,
    }

})();
